module.exports = __webpack_public_path__ + "static/media/top_prod_4.c255eda3.png";